// Video Section 
jQuery(document).ready(function () {
  var video = jQuery('.video_element')[0];
  var btn = jQuery('#play_btn');
  btn.on('click', function (e) {
    e.preventDefault();
    video.play();
    jQuery(video).attr('controls', true);
    btn.hide();
  });
});

// KT customer testimonials
const testimonial = document.querySelector('.customer_review');
if (testimonial){
const splide = new Splide('.customer_review', {
    type: 'loop',
    rewind: true,
    pagination: false,
    perPage: 2,
    breakpoints: {
      767: {
          perPage: 1,
          gap: '10px',            
      },
    },
    gap: '30px',
    arrows: false,
})

document.querySelector('.splide_next').addEventListener('click', e => {
  splide.go('+1')
})

document.querySelector('.splide_prev').addEventListener('click', e => {
  splide.go('-1')
})

splide.mount()

};

// infinite scroll
document.addEventListener('DOMContentLoaded', function () {
  const sliderElement = document.querySelector('.continue_slide');
  if (!sliderElement) return;

  const slides = sliderElement.querySelectorAll('.splide__slide');
  const slideCount = slides.length;

  const breakpoints = {
    440: 2,
    680: 4,
    767: 4,
    880: 4,
    1024: 5,
  };

  let splideInstance = null;
  let currentPerPage = null;

  function getPerPage() {
    const width = window.innerWidth;
    const sorted = Object.keys(breakpoints).map(Number).sort((a, b) => a - b);
    for (const bp of sorted) {
      if (width <= bp) return breakpoints[bp];
    }
    return 6; // desktop
  }

  function setStaticMode() {
    sliderElement.classList.add('center-static-slides');
    const wrapper = sliderElement.closest('.infinite_slider');
    if (wrapper) wrapper.classList.add('static-mode');
    sliderElement.classList.add('slider-ready');
  }

  function clearStaticMode() {
    sliderElement.classList.remove('center-static-slides');
    const wrapper = sliderElement.closest('.infinite_slider');
    if (wrapper) wrapper.classList.remove('static-mode');
  }

  function mountSlider(perPage) {
    splideInstance = new Splide(sliderElement, {
      type: 'loop',
      perPage: perPage,
      gap: '3rem',
      arrows: false,
      pagination: false,
      drag: true,
      autoScroll: {
        speed: 1,
      },
      breakpoints: {
        1024: { perPage: 5, gap: '3rem' },
        880: { perPage: 4, gap: '2rem' },
        767: { perPage: 4, gap: '2rem' },
        680: { perPage: 4, gap: '1rem' },
        440: { perPage: 2, gap: '1.5rem' },
      },
    });

    splideInstance.on('mounted', function () {
      sliderElement.classList.add('slider-ready');
    });

    splideInstance.mount(window.splide.Extensions);
  }

  function initSlider() {
    sliderElement.classList.remove('slider-ready');
    const perPage = getPerPage();

    if (splideInstance) {
      splideInstance.destroy(true);
      splideInstance = null;
    }

    if (slideCount >= perPage) {
      clearStaticMode();
      mountSlider(perPage);
    } else {
      setStaticMode();
    }

    currentPerPage = perPage;
  }

  initSlider();

  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newPerPage = getPerPage();
      if (newPerPage !== currentPerPage) {
        initSlider();
      }
    }, 200);
  });
});


  
  // Product detail page
  // document.addEventListener("DOMContentLoaded", function () {
  //   const customSizeRadio = document.getElementById("size5");
  //   const customSizeField = document.querySelector(".custom-size-field");

  //   customSizeRadio.addEventListener("change", function () {
  //     if (this.checked) {
  //       customSizeField.classList.add("active");
  //     }
  //   });

  //   document.querySelectorAll('input[name="select-cut"]').forEach(radio => {
  //     if (radio.id !== "size5") {
  //       radio.addEventListener("change", function () {
  //         customSizeField.classList.remove("active");
  //       });
  //     }
  //   });
  // });
  // // 

  // document.addEventListener('DOMContentLoaded', function () {
  //   function updateCheckedClasses() {
  //     document.querySelectorAll('.cut_item,.size-option,.quantity-item').forEach(item => {
  //       const input = item.querySelector('input[type="radio"]');
  //       if (input && input.checked) {
  //         item.classList.add('checked');
  //       } else {
  //         item.classList.remove('checked');
  //       }
  //     });
  //   }

  //   // Add event listener to all radio buttons
  //   document.querySelectorAll('input[type="radio"]').forEach(input => {
  //     input.addEventListener('change', updateCheckedClasses);
  //   });

  //   // Initial check on page load
  //   updateCheckedClasses();
  // });



// Product detail page  
// document.addEventListener("DOMContentLoaded", function () {
  // const customSizeRadio = document.getElementById("size5");
  // const customSizeField = document.querySelector(".custom-size-field");

  // if (customSizeRadio && customSizeField) {
  //   customSizeRadio.addEventListener("change", function () {
  //     if (this.checked) {
  //       customSizeField.classList.add("active");
  //     }
  //   });

  //   document.querySelectorAll('input[name="select-size"]').forEach(radio => {

  //     console.log(radio.id, "<< [[  radio.id")
      
  //     // if (radio.id !== "size5") {
  //     //   radio.addEventListener("change", function () {
  //     //     customSizeField.classList.remove("active");
  //     //   });
  //     // }
  //   });
  // }
// });

 

// document.addEventListener('DOMContentLoaded', function () {
//   function updateCheckedClasses() {
//     document.querySelectorAll('.cut_item,.size-option,.quantity-item').forEach(item => {
//       const input = item.querySelector('input[type="radio"]');
//       if (input && input.checked) {
//         item.classList.add('checked');
//       } else {
//         item.classList.remove('checked');
//       }
//     });
//   }

//   // Add event listener to all radio buttons
//   document.querySelectorAll('input[type="radio"]').forEach(input => {
//     input.addEventListener('change', updateCheckedClasses);
//   });

//   // Initial check on page load
//   updateCheckedClasses();
// });

document.addEventListener('DOMContentLoaded', function () {
  const customQty = document.querySelector('.custom-qty-input');
  const orderButton = document.getElementById('order-button');
  const customQtyInput = customQty?.querySelector('.quantity-custom-input');


  if (customQtyInput?.checked) {
    customQty.classList.add('checked');
  }

  function updateCheckedClasses({ skipQuantityRemoval = false } = {}) {
    // Handle cut_item & size-option
    ['.cut_item', '.size-option'].forEach(selector => {
      document.querySelectorAll(selector).forEach(item => {
        const input = item.querySelector('input[type="radio"]');
        // console.log(input, "<<< input >>")
        item.classList.toggle('checked', input?.checked);
      });
    });

    // Handle quantity-item radios
    const qtyRadios = document.querySelectorAll('.quantity-item input[type="radio"]');
    qtyRadios.forEach(input => {
      const item = input.closest('.quantity-item');
      if (input.checked) {
        if (!skipQuantityRemoval) {
          document.querySelectorAll('.quantity-item').forEach(q => q.classList.remove('checked'));
        }
        item.classList.add('checked');
        customQty?.classList.remove('checked', 'quantity-item');
      } else if (!skipQuantityRemoval) {
        item.classList.remove('checked');
      }
    });
  }

  // Radio change event
  document.querySelectorAll('.wrap-data input[type="radio"]').forEach(input => {
    input.addEventListener('change', () => {
      updateCheckedClasses();
      checkAllGroupsSelected();
    });
  });

document.addEventListener('click', function(e) {
  // Check if the clicked element is a quantity radio
  if (e.target.matches('.wrap-data .quantity-list_wrapper input[type="radio"]')) {
    console.log(e.target.id, "<< quantity radio clicked");

    // Remove error message
    const errorBox = document.querySelector(".custom-error-msg");
    if (errorBox) {
      errorBox.textContent = "";
      errorBox.style.display = "none";
    }

    // Optional: remove error class from wrappers
    document.querySelectorAll('.quantity-item, .custom-qty-input').forEach(item => {
      item.classList.remove('error');
    });
  }
});


  // Custom quantity click
  customQty?.addEventListener('click', () => {
    document.querySelectorAll('.quantity-item').forEach(item => {
      item.classList.remove('checked');
      const radio = item.querySelector('input[type="radio"]');
      if (radio) radio.checked = false;
    });
    customQty.classList.add('quantity-item', 'checked');
    checkAllGroupsSelected();
  });


  // Optional: enable/disable order button
  function checkAllGroupsSelected() {
    const selected = ['.cut_item', '.size-option'].every(selector =>
      [...document.querySelectorAll(`${selector} input[type="radio"]`)].some(input => input.checked)
    );
    const hasQty = [...document.querySelectorAll('.quantity-item input[type="radio"]')].some(i => i.checked) ||
                   customQty?.classList.contains('checked');

    if (orderButton) orderButton.disabled = !(selected && hasQty);
  }

  updateCheckedClasses({ skipQuantityRemoval: true });
  checkAllGroupsSelected();
});


// New Code File upload  
// jQuery(document).ready(function () {
//   var input = jQuery('#artwork-upload');
//   var fileNameDisplay = jQuery('.file-name');
//   var uploadText = jQuery('.upload-text-small');
//   var dropArea = jQuery('#drop-area');

//   var allowedExtensions = ['ai', 'svg', 'eps', 'png', 'jpg', 'jpeg', 'psd'];
//   var currentValidFile = null;
//   var maxFileSizeMB = 10;

//   function getFileExtension(filename) {
//     return filename.split('.').pop().toLowerCase();
//   }

//   function isValidFile(file) {
//     var ext = getFileExtension(file.name);
//     return allowedExtensions.includes(ext);
//   }

//   function isValidSize(file) {
//     var fileSizeMB = file.size / (1024 * 1024);
//     return fileSizeMB <= maxFileSizeMB;
//   }

//   function updateDisplay(file) {
//     fileNameDisplay.text(file.name);
//     uploadText.hide();
//   }

//   function handleFile(file) {
//     if (!isValidFile(file)) {
//       var ext = getFileExtension(file.name);
//       alert(`.${ext} file type is not allowed.`);
//     } else if (!isValidSize(file)) {
//       alert("Files larger than 10MB cannot be uploaded.");
//     } else {
//       currentValidFile = file;
//       updateDisplay(file);
//       return;
//     }

//     if (currentValidFile) {
//       updateDisplay(currentValidFile);
//     } else {
//       input.val('');
//       fileNameDisplay.text('No file chosen');
//       uploadText.show();
//     }
//   }

//   input.on('change', function () {
//     var file = this.files[0];
//     handleFile(file);
//   });

//   dropArea.on('dragover', function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     dropArea.addClass('drag-over');
//   });

//   dropArea.on('dragleave', function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     dropArea.removeClass('drag-over');
//   });

//   dropArea.on('drop', function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     dropArea.removeClass('drag-over');

//     var dt = e.originalEvent.dataTransfer;
//     var files = dt.files;

//     if (files.length > 0) {
//       var file = files[0];

//       if (isValidFile(file) && isValidSize(file)) {
//         var dataTransfer = new DataTransfer();
//         dataTransfer.items.add(file);
//         input[0].files = dataTransfer.files;
//         input.trigger('change');
//       } else {
//         if (!isValidFile(file)) {
//           var ext = getFileExtension(file.name);
//           alert(`.${ext} file type is not allowed.`);
//         } else {
//           alert("Files larger than 10MB cannot be uploaded.");
//         }

//         if (currentValidFile) {
//           var dataTransfer = new DataTransfer();
//           dataTransfer.items.add(currentValidFile);
//           input[0].files = dataTransfer.files;
//         } else {
//           input.val('');
//           fileNameDisplay.text('No file chosen');
//           uploadText.show();
//         }
//       }
//     }
//   });

//   dropArea.on('click', function () {
//     input.trigger('click');
//   });
  
// });
// New Code File upload Ends 



$(document).ready(function () {
  $('.inn_form label, .size-selection label, .quantity-item label').on('click', function () {
    const $parent = $(this).parent();
    const $input = $parent.find('input[type="radio"]');

    $input.prop('checked', true).trigger('change');
    $parent.addClass('checked').siblings().removeClass('checked');
  });

  $('.size-selection input[type="radio"]').on('change', function () {

    const errorBox = document.querySelector(".custom-error-msg");
    if (errorBox) {
        errorBox.textContent = "";
        errorBox.style.display = "none";
    }

    const selectedValue = $(this).val().toLowerCase();
    if (selectedValue == 'custom size') {
      $('.custom-size-field').addClass('active');
    } else {
      $('.custom-size-field').removeClass('active');
    } 
  });

   $('.quantity-list_wrapper input[type="radio"]').on('change', function () {
     const errorBox = document.querySelector(".custom-error-msg");
    if (errorBox) {
        errorBox.textContent = "";
        errorBox.style.display = "none";
    }
   });

  
  const selectedRadio = $('.size-selection input[type="radio"]:checked');
  if (selectedRadio.length && selectedRadio.val().toLowerCase() === 'custom size') {
    $('.custom-size-field').addClass('active');
  } else {
    $('.custom-size-field').removeClass('active');
  }
  
  $('.quantity-list .quantity-custom-input').on('click', function() {
    $(this).closest('label').trigger('click');
  });



});

$(window).load(function(){
  if($('input[name="Finish-2"][value="Matte"]').length > 0){
      $('input[name="Finish-2"][value="Matte"]').parents('.box.finish').hide();
      $('input[name="Finish-2"][value="Matte"]').trigger('click');
  }
  
})